import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreateNovel from "./components/CreateNovels.jsx/CreateNovel";
import NoUserNovels from "./components/UserNovels/NoUserNovels";
import UserNovels from "./components/UserNovels/UserNovels";

import { getUserNovel, getChapters } from "../3- actions/novels";
import { Helmet } from "react-helmet";

function Create({ setInterfaces, setPopUp }) {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const userId = user?.result?._id;
  const novels = useSelector((state) => state.novelsData.userNovels);

  useEffect(() => {
    if (novels?.novels?.length === undefined && userId) {
      // CREATE // get all novelXchapter of my localStorage user
      dispatch(getUserNovel(userId));
      dispatch(getChapters(userId));
    }
  }, []);

  return (
    <div className="px-[15px] md:px-0 my-[100px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>EyeNovel | Read Free Online Novels in Your Favor</title>
        <meta
          name="description"
          content="Create novel stories online at EyeNovel. You can find create fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />

        {/* <!-- Google / Search Engine Tags --> */}
        <meta
          itemprop="name"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          itemprop="description"
          content="Create novel stories online at EyeNovel. You can find create fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />
        <meta
          itemprop="image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:url" content="https://eyenovel.netlify.app" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          property="og:description"
          content="Create novel stories online at EyeNovel. You can find create fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />
        <meta
          property="og:image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          name="twitter:description"
          content="Create novel stories online at EyeNovel. You can find create fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />
        <meta
          name="twitter:image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />
        <meta name="author" content="Osama Daimallah" />
      </Helmet>
      <CreateNovel
        user={user}
        setInterfaces={setInterfaces}
        setPopUp={setPopUp}
      />
      <h1 className="flex justify-center mt-[100px] font-size text-center relative text-tertiary ">
        Your novels
      </h1>
      {novels?.novels?.length > 0 && novels.pending === false && (
        <UserNovels novel={novels?.novels} user={user} />
      )}
      {novels?.pending === false && novels?.novels?.length === 0 && (
        <NoUserNovels />
      )}
      {!userId && <NoUserNovels />}
      <div className="">
        <div
          className={
            novels?.pending === true
              ? " scale-125 flex w-fit justify-center items-center text-center m-auto mt-40 mb-80"
              : " scale-125 hidden w-fit justify-center items-center text-center m-auto mt-40 mb-80"
          }
          role="status"
        >
          <svg
            aria-hidden="true"
            className=" w-8 h-8  animate-spin text-gray-600 fill-primary"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
        <div
          className={
            novels?.pending === false && novels.novels.length !== 0
              ? "text-tertiary block mt-16 mb-[200px]"
              : "text-tertiary hidden mt-16 mb-[200px]"
          }
        >
          <div className="capitalize flex flex-col justify-center items-center space-y-4">
            <div className="w-full h-[1px] bg-primary"></div>
            <h3 className="text-[14px] md:text-[16px] text-center">
              You have reached the bottom of this page ^^
            </h3>
            <div className="w-full h-[1px] bg-primary"></div>
          </div>
        </div>
      </div>
      {/* <Loading /> */}
    </div>
  );
}

export default Create;
